export default __webpack_public_path__ + "static/media/Biohazardous_Waste.7083eb37.svg";